/**
 * Created by sung on 2017-02-07.
 */
import {NgModule, Component, OnInit, group, ViewChild} from '@angular/core';
import {PanelModule,DataTableModule,ButtonModule,TreeModule,PaginatorModule, DropdownModule, FileUploadModule, InputTextareaModule, InputTextModule, ConfirmDialogModule, ConfirmationService} from 'primeng/primeng';
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {BrowserModule} from "@angular/platform-browser";


import {RouterModule} from "@angular/router";
import {MamAdminService} from '../../service/mam_service.component';
import { User } from '../../model/user';
import {SelectItem} from "primeng/components/common/api";
import {SearchModule} from "../../component/search.component";
import {ExDialogModule} from "../../component/dialog.component";
import { UserTitle } from '../../model/usertitle';
import { ThirdPartyCompany } from '../../model/thirdpartycompany';

//import {UserGroupTreeModule} from "../../component/user_tree.component";
import {UserGroup} from '../../model/usergroup';
import {ExUserDialogModule} from "../../component/user_dlg.component";
import {Paginator} from "primeng/components/paginator/paginator";

import { URLSearchParams,Headers} from '@angular/http';
import {HttpModule,Response} from "@angular/http";

import {AttributeType} from "../../model/attribute_type";
import {AttributeValue} from "../../model/attribute_value";

import {CompanyDropDownListModule,AttributeGroupTreeModule} from "../../component/component";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service"; // ADD THIS

import {FileUpload} from "primeng/components/fileupload/fileupload";
import * as glob from "../../service/global_url";

@Component({
  selector:'device-user-management',
  templateUrl:'./device_user_management.html'
})
export class DeviceUserManagementComponent implements OnInit {

  private selected_group:UserGroup = Object.assign({});
  @ViewChild('pagin') pagin : Paginator;
  @ViewChild('upload') upload : FileUpload;

  private user_list : User[] = [];
  private company_list :ThirdPartyCompany[] =[];
  private user_title_list : UserTitle[] = [];

  private attributes : AttributeType[];
  private attrss : any;
  private selectedCompany : any;
  private attrValueList : any;

  selectedTitle : UserTitle;

  addForm : FormGroup;
  totalRecord: number=0;
  licenseCount: number=0;
  searchIDs: SelectItem[];
  selectedUserTitle : SelectItem[];
  // selectedCompany : SelectItem[];
  table_list: any;
  addUpdateShow = false;
  dateIsTrue : boolean;
  selectedUser:User;

  searchIsTrue : boolean;
  excelIsTrue : boolean = true;
  searchText: string;
  searchId : string;
  sDate : string;
  eDate : string;
  pageMax:number =10;

  title : string;
  detailShow : boolean;
  selectedDetailUser : any;
  adddialogWidth : number = 800;

  pass : string;
  passConfirm : string;

  passwordCheckResult : any;
  selectIsTrue : boolean = false;
  width: any;
  type: string;
  visible : boolean = false;

  uploadUrl:string;
  excelUserAddShow :boolean = false;
  binaryFilePath : any = [];
  companyList : SelectItem[]=[];

  excelUserAddResult : any ="";
  uploadedFiles : any =[];
  translate : TranslateServiceForm;
  kyungnamIsUse : boolean = glob.kyungnamIsTrue;
  constructor(private service: MamAdminService, private fb: FormBuilder, private logger : Logger, private _translate : TranslateServiceForm, private confirmationService: ConfirmationService) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('ManagementName'), value: 'name'});
    this.searchIDs.push({label: this.translate.instant('LANG_LoginID'), value: 'username'});
    this.searchIDs.push({label: this.translate.instant('LANG_MemberNum'), value: 'membernum'});
    this.searchIDs.push({label: this.translate.instant('LANG_Self_Device_lock_status'), value: 'isLock'});

    this.dateIsTrue = false;


  }

  ngOnInit() {
    //this.getUserList(1,"C", 1, 10, '','','');

    this.getUserTitle();
    this.loadAttributeList();
  }
  loadAttributeList():void{
    var url = "/mgr/system/attribute/type/all"
    var p_params = new URLSearchParams();
    p_params.set("companyId" ,String(3));
    this.service.get(url,null,p_params).subscribe(
        value => {
          this.logger.debug("loadAttributeList : " , value);
          this.attributes = value;
        },error=>{this.logger.error("-- error : " + error); }
    )
  }
  onGroupSelect(event){
    this.logger.debug("selected group : " , event);
    this.selected_group = event;
    if(this.pagin){
      this.pagin.first=0;
    }
    this.getGroupUserList(event.id,0,10);

  }
  getSearchModel(event){
    //console.log("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;
    this.logger.debug( " ========> " , this.selected_group.id);
    //console.log( " ========> " , this.selected_group.id);
    this.getGroupUserListBySearch(this.selected_group.id, 0, this.pageMax, this.searchText, this.searchId);
    if(this.pagin){
      this.pagin.first=0;
    }
  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      this.getGroupUserListBySearch(this.selected_group.id, event.page, event.rows, this.searchText, this.searchId);

    } else {
      //this.getUserList(1,"C",event.page + 1,this.pageMax,"","","");
      this.getGroupUserList(this.selected_group.id,event.page,this.pageMax);
    }
  }
  selectDetailUser(item){
    this.selectedDetailUser = item;
    this.title = this.translate.instant('DetailColumn');
    //this.detailShow= true;

    this.width=700;
    this.type = "detail";
    this.visible = true;

  }

  //----------------------- SERVICE --------------------------------------------

  /*getUserList(targetId:number, targetType:string, page:number, max:number, search:string, like:string, field:string){
   this.service.getUserList(targetId, targetType, page, max, search, like, field).subscribe(
   value => {
   //this.user_list = value.rows;
   this.table_list = value.rows;
   this.totalRecord = value.total;
   this.logger.debug("-- user_list :", value);
   },
   error => {
   this.logger.error("-- error : " + error);
   },
   () => {
   this.logger.info("-- complate : ");
   }
   )
   }

   updateUserInfo(userId:number, user:any) {
   this.service.updateUserInfo(userId, user).subscribe(
   value => {
   let result = value;
   this.logger.debug("-- result :", result);
   },
   error => {
   this.logger.error("-- error : " + error);
   },
   () => {
   this.logger.info("-- complate : ");
   this.addForm.reset();
   this.addUpdateShow = false;
   }
   )
   }*/

  passwordChecker(password:string) {
    this.service.passwordChecker(password).subscribe(
        value => {
          this.passwordCheckResult = value;
          this.logger.debug("-- result :", this.passwordCheckResult);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          if(this.passwordCheckResult == 'OK'){

          } else {
            alert(this.passwordCheckResult);
          }

          this.logger.info("-- complate : ");
        }
    )
  }

  deleteUserInfo(userId:number, user:any) {
    this.service.deleteUserInfo(userId).subscribe(
        value => {
          let result = value;
          this.logger.debug("-- dele_result :", result);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  getUserTitle() {
    this.service.getUserTitle().subscribe(
        value => {
          this.user_title_list = value.rows;
          this.logger.debug("-- user_title_list :", this.user_title_list);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.selectedUserTitle = [];
          this.user_title_list.forEach(title => {
            this.selectedUserTitle.push({label: title.name, value: title});
          })
          this.selectedTitle = this.user_title_list[0];
        }
    )
  }

  getGroupUserList(groupId: number,page: number,size : number){
    this.service.getGroupUserList(groupId,page,size).subscribe(
        value => {
          let tempLis : any;
          tempLis = value;
          this.table_list = value.content;
          if(this.table_list && this.table_list.length>0){
            //console.log(this.table_list);
            this.table_list.forEach(item => {
              let userAttributes = [];
              let userAttrTypeValuetiedLists = [];

              this.service.getUserAttributeValueListsAndRoots(item.id).subscribe(
                  value=>{
                    for(let i =0;i<value.length/2;i++){
                      //console.log("label : "+value[i+(value.length/2)].name);
                      //console.log("value : "+value[i].name);
                      userAttrTypeValuetiedLists.push({label: value[i+(value.length/2)].name,value : value[i].name});
                      item[value[i+(value.length/2)].name] = value[i].name;
                    }
                    /*value.forEach(item => {
                     userAttributes.push({label: item.label, value:item});
                     });*/
                    this.logger.debug("userAttrTypeValuetiedLists",userAttrTypeValuetiedLists);

                  },
                  error => {this.logger.error("-- error : " + error); });
            })
          }

          this.totalRecord = value.totalElements;
          this.licenseCount = value.licenseCount;
          this.logger.debug("-- tempLis :", tempLis);
        },error => {
          this.logger.error("-- error : " + error);
        },() => {

        }
    )
  }

  getGroupUserListBySearch(groupId: number, page: number, size: number, search:string, field:string){
    this.service.getGroupUserListBySearch(groupId,page,size,search,field).subscribe(
        value => {
          this.table_list = value.content;
          this.totalRecord = value.totalElements;
          this.licenseCount = value.licenseCount;
          this.logger.debug("-- getGroupUserListBySearch :", value);
          if(this.table_list && this.table_list.length>0){

            this.table_list.forEach(item => {
              let userAttributes = [];
              let userAttrTypeValuetiedLists = [];

              this.service.getUserAttributeValueListsAndRoots(item.id).subscribe(
                  value=>{
                    for(let i =0;i<value.length/2;i++){
                      //console.log("label : "+value[i+(value.length/2)].name);
                      //console.log("value : "+value[i].name);
                      userAttrTypeValuetiedLists.push({label: value[i+(value.length/2)].name,value : value[i].name});
                      item[value[i+(value.length/2)].name] = value[i].name;
                    }
                    /*value.forEach(item => {
                     userAttributes.push({label: item.label, value:item});
                     });*/
                    this.logger.debug("userAttrTypeValuetiedLists",userAttrTypeValuetiedLists);

                  },
                  error => {this.logger.error("-- error : " + error); });
            })
          }

          this.totalRecord = value.totalElements;
          this.licenseCount = value.licenseCount;
        },error => {
          this.logger.error("-- error : " + error);
        },() => {}
    )
  }

  unLockUser(userId : number){
    this.service.unLockUser(userId).subscribe(
        value => {
          this.logger.debug("value",value);
          alert(value);
          this.getGroupUserList(this.selected_group.id,0,10);

        },error => {
          this.logger.error("-- error : " + error);
        }
    )
  }

  deleteInactiveUser(userId : number){
    this.service.deleteInactiveUser(userId).subscribe(
        value => {
          this.logger.debug("value",value);
          alert(value);
          this.getGroupUserList(this.selected_group.id,0,10);

        },error => {
          this.logger.error("-- error : " + error);
        }
    )
  }

  getAttributeTypeList(companyId : number, page: number, size: number){
    this.service.getAttributeTypeList(companyId,page,size).subscribe(
        value => {
          this.logger.debug("이회사의 속성 type정의 : ",value);
          this.attrss=[];
          if(value && value.length > 0){
            value.forEach(item => {
              this.attrss.push({label: item.name});
            })
          }
        },error => {
          this.logger.error("-- error : " + error);
        }
    )
  }

  getAttributeValueAllList(companyId : number){
    this.service.getAttributeValueAllList(companyId).subscribe(
        value => {
          this.logger.debug("이회사의 속성 값정의 : ",value);
          this.attrValueList =[];
          if(value && value.length > 0){
            value.forEach(item => {
              this.attrValueList.push({label: item.name});
            })
          }
        },error => {
          this.logger.error("-- error : " + error);
        }
    )
  }

  excelExport(event){
    this.logger.debug("excel 다운 : ",event);
    if(event){
      /*this.service.companyUserDownloadExcel(this.selectedCompany.id).subscribe(
          value=>{this.logger.debug("-- val : " + value);},
          error=>{this.logger.error("-- error : " + error);}
      )*/
      var url = this.service.getUrl() + "/mgr/system/user/company/" + this.selectedCompany.id+"/download/excel";
      window.open(url);
    }
  }

  //----------------------- Event_ ----------------------------------------------
  onSelectedCompany(company) {
    this.selectedCompany = company;
    this.table_list = [];
    this.companyList = [];
    this.companyList.push({label: company.name,value:company});
    this.logger.debug("combo - select :" , this.selectedCompany);
    this.getAttributeTypeList(company.id,0,30);
    this.getAttributeValueAllList(company.id);

  }
  onChange(event) {
    this.selectedTitle = event.value;
    this.logger.debug("onChangeTitle :" , event);
  }

  updateBtn(event) {
    if(this.selectIsTrue){
      //this.addUpdateShow = true;
      this.visible = true;
    }else{
      alert(this.translate.instant('MESSAGE_Select_User_First'));
    }
    this.title = this.translate.instant('LANG_msgModify');
    this.width = 700;
    this.type = "update";

    this.logger.debug(" 수정:", event);
  }


  delBtn(event){
    this.logger.debug("del",this.selectedUser);

    var url_path = "/mgr/system/user";
    this.service.del(url_path,String(this.selectedUser.id),null).subscribe(
        value => {
          this.logger.debug("-- value : " , value);
        },error=>{this.logger.error("-- error : " + error);}
    )
  }

  addBtn(event){
    this.logger.info(" 추가: ",event);

    if(this.attrValueList.length >0){
      this.visible = true;
      this.title = this.translate.instant('BUTTON_ADD');
      this.width = 700;
      this.type="add";
    }else{
      alert(this.translate.instant('MESSAGE_Add_Attribute_First'));
    }
  }

  confirm(event){
    this.detailShow = false;
  }

  onSubmit(data) {
    //console.log("data는 ? : ",data);
    var companyId:number;
    var att_list:any=[];
    var log = this.logger;
    Object.getOwnPropertyNames(data).forEach(
        function (val, idx, array) {
          if(data[val].name == undefined){
            log.debug("add param : " + val + ' -> ' + data[val]);
          }else{
            if(val == "company"){
              log.debug("company   : " + ' -> ' + "name : " +data[val].name + ":" + data[val].id);
              companyId = data[val].id;
            }else{
              var att_id = data[val].id;
              log.debug("attribute : " + ' -> ' + "name : " +data[val].name + ":" + data[val].id);
              att_list.push(att_id);
            }
          }
        }
    );

    var body = {
      id:data["id"],
      name:data["name"],
      username:data["username"],
      password:data["password"],
      email: data["email"],
      membernum:data["membernum"],
      company :data["company"],
      use:true,
      attributes:att_list,
      dCode : data['deptCode']
    };
    if(data.isUse == "USE") body.use = true;
    else body.use = false;

    //console.log(body);

    this.logger.debug("submit type : " + this.type);
    if(this.type=="add"){
      var url = "/mgr/system/user";
      this.service.post_requestBody(url,null,body).subscribe(
          value =>{
            this.logger.debug("add result : ", value);
            //this.getGroupUserList(this.selected_group.id,0,this.pageMax);
            this.getGroupUserListBySearch(this.selected_group.id,0,this.pageMax,"","");
          },error => {this.logger.error("-- error : " + error); }
      );
    }else if(this.type =="update"){
      var url = "/mgr/system/user";
      this.service.put(url,null,body).subscribe(
          value =>{
            this.logger.debug("update result : ", value);
            //this.getGroupUserList(this.selected_group.id,0,this.pageMax);
            this.getGroupUserListBySearch(this.selected_group.id,0,this.pageMax,"","");
            this.pagin.first=0;
          },error => {this.logger.error("-- error : " + error); }
      );
    }else{
      this.logger.debug("-undefined-");
    }
  }

  onRowSelect(event) {
    //this.logger.debug("event :", event);
    this.selectIsTrue = true;
    this.selectedDetailUser = event.data;
  }

  excelUserAdd(event){
    this.excelUserAddShow = true;
    this.title = this.translate.instant('LANG_Excel_User_Registration');
    this.binaryFilePath = "";
    this.excelUserAddResult = "";
    this.uploadedFiles = [];
    this.uploadUrl = this.service.getUrl() + "/mgr/system/user/import/" + this.selectedCompany.id;
  }

  excelFormDownload(event){
    this.logger.debug("download >>");
    var url = this.service.getUrl() + "/mgr/system/user/export/" + this.selectedCompany.id;
    window.open(url);
  }

  /*onSelects(event) {
    var fileName = "";
    for(let file of event.files) {
      fileName = file.name;
    }

    this.confirmationService.confirm({
      header: this.translate.instant('LANG_File_Upload'),
      message: fileName + " " + this.translate.instant('LANG_File_Upload_Confirm'),
      icon: 'fa',
      accept: () => {
        this.upload.url = this.uploadUrl;
        this.upload.upload();
      },
      reject: () => {
        this.upload.clear();
        this.binaryFilePath = "";
        this.excelUserAddResult = "";
        this.uploadedFiles = [];
      }
    });
  }*/

  onUploads(event) {
    //console.debug("파일입니다 ㅋ", event);
    //console.debug(JSON.parse(event.xhr.responseText));
    let temp = JSON.parse(event.xhr.responseText);
    for(let item of temp){
      this.excelUserAddResult += item.username + " : "+ item.result+"\n";
    }

    for(let file of event.files) {
      this.logger.debug("file :", file.name);
      this.binaryFilePath = file.name;
      this.uploadedFiles.push(file);
    }
  }

  excelUserAddConfirm(){
    this.excelUserAddShow = false;
    /*var params = new URLSearchParams();
     params.set('file', this.binaryFilePath);
     this.service.post(this.uploadUrl,null,params).subscribe(
     value =>{
     console.debug("excelUser AddResult : ", value);
     },error => {console.error("-- error : " + error); }
     )*/
  }
  excelUserAddCancel(){
    this.excelUserAddShow = false;
  }

  userLockEnable(user){
    this.logger.debug("잠금 해제");
    this.unLockUser(user.id);
  }

  userDelete(user) {
    if(confirm(this.translate.instant('MESSAGE_ALERT_CONFIRM_DELETE'))) {
      this.deleteInactiveUser(user.id);
    }
  }
}

@NgModule({
  imports:[ReactiveFormsModule, PanelModule, DataTableModule, ButtonModule, TreeModule,
    CommonModule,BrowserModule,HttpModule, RouterModule,FormsModule,SearchModule,PaginatorModule,ExDialogModule,
    DropdownModule,ExUserDialogModule,FileUploadModule,
    CompanyDropDownListModule,AttributeGroupTreeModule,InputTextareaModule,InputTextModule,TranslatePipeMoudle,ConfirmDialogModule],
  declarations:[DeviceUserManagementComponent],
  exports:[DeviceUserManagementComponent],
  providers:[MamAdminService, ConfirmationService]
})
export class DeviceUserManagementModule{

}



// WEBPACK FOOTER //
// ./src/app/page/system/device_user_management.ts